import { Fragment, useMemo, useState } from 'react';
import { Grid, Stack } from '@mui/material';
import TableItemsEditable from '../tableEditable/TableItemsEditable.component';
import ModalLogbook from '../../logbook/modal/ModalLogbook.component';
import { SimpleCreateConf } from '../../../module/logbook/conf/SimpleCreate.conf';
import _ from 'lodash';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import { SimpleUpdateLogbookConf } from '../../../module/logbook/conf/SimpleUpdate.conf';
import PaperTypography from '../../common/PaperTypography.component';
import {
  HEIGHT_TABLE_ITEMS,
  STATUS_ENABLE_SEND_LOGBOOK,
} from '../../../module/listItem/conf/Data.conf';

const TabCreateLogbook = ({
  dataGrouped,
  setSuccess = () => {},
  optionsSuppliersLogbook,
  module,
  moduleDepartment,
}) => {
  const [checked, setChecked] = useState(null);
  const [openRows, setOpenRows] = useState({ 'NEW ITEM': true });

  const productsList = useMemo(
    () => _.flatMap(checked, (group) => _.keys(_.pickBy(group, Boolean))),
    [checked]
  );
  const data = useMemo(
    () =>
      dataGrouped &&
      dataGrouped.filter((item) =>
        _.includes(STATUS_ENABLE_SEND_LOGBOOK, _.first(Object.keys(item)))
      ),
    [dataGrouped]
  );

  const dataNoEmpty = useMemo(
    () =>
      _.some(data, (item) => {
        const value = Object.values(item)[0];
        return value !== undefined;
      }),
    [data]
  );

  const onSelectItem = ({ id, status, available }) => {
    setChecked({
      ...checked,
      [available]: {
        ...checked?.[available],
        [id]: status,
      },
    });
  };

  const onSelectAll = (key, products) => {
    const numSelected = _.keys(_.pickBy(checked?.[key], _.identity))?.length;
    const isChecked =
      (products?.length > 0 && products?.length === numSelected) || false;
    setChecked({
      ...checked,
      [key]: products?.reduce((acc, item) => {
        acc[item?.id] = !isChecked;
        return acc;
      }, {}),
    });
  };

  const toggleRow = (rowId) => {
    setOpenRows((prev) => ({ ...prev, [rowId]: !openRows?.[rowId] || false }));
  };

  return dataNoEmpty ? (
    <Fragment>
      <Stack spacing={5} m={2} direction={'row'}>
        <ModalLogbook
          disabled={!(productsList?.length !== 0)}
          conf={SimpleCreateConf}
          setSuccess={setSuccess}
          productsList={productsList}
          setChecked={setChecked}
          module={moduleDepartment}
          endIcon={<SendIcon />}
        />

        <ModalLogbook
          disabled={
            !(productsList?.length !== 0) ||
            !(optionsSuppliersLogbook?.length !== 0)
          }
          conf={_.update(SimpleUpdateLogbookConf, 'fields', (fields) =>
            fields.map((field) =>
              field.id === 'id_supplier'
                ? {
                    ...field,
                    options: optionsSuppliersLogbook,
                  }
                : field
            )
          )}
          setSuccess={setSuccess}
          productsList={productsList}
          setChecked={setChecked}
          module={moduleDepartment}
          label='Add to an existing logbook'
          endIcon={<AddIcon />}
        />
      </Stack>

      <Grid container spacing={5}>
        {data?.map((item) => {
          const key = _.head(Object.keys(item));
          const id = `managelogbook-${key}`;

          return (
            item?.[key] && (
              <Grid item xs={12} key={id}>
                <TableItemsEditable
                  data={item?.[key]}
                  setSuccessEdit={setSuccess}
                  onSelectItem={onSelectItem}
                  checked={checked?.[key]}
                  onSelectAll={() => onSelectAll(key, item?.[key])}
                  label={key}
                  module={module}
                  height={HEIGHT_TABLE_ITEMS}
                  toggleRow={toggleRow}
                  open={openRows?.[key]}
                />
              </Grid>
            )
          );
        })}
      </Grid>
    </Fragment>
  ) : (
    <PaperTypography title={'No items have been added to this section'} />
  );
};

export default TabCreateLogbook;
